import React from 'react';
import TimeOfUse from './rateTypes/TimeOfUse';
import SlabBased from './rateTypes/SlabBased';
import FlatRate from './rateTypes/FlatRate';
import Seasonal from './rateTypes/Seasonal';

export default function Overview({ rateDetail }: { rateDetail?: any }) {
  const typeDisplay = rateDetail?.rateTypeDisplay || 'NA';

  let content = null;
  if (typeDisplay === 'Time of Use' || rateDetail?.basisType == "Time Of Use" ) {
    content = <TimeOfUse slots={rateDetail?.rate || []} />;
  } else if (typeDisplay === 'Slab Based' || rateDetail?.basisType == "Slab" || rateDetail?.basisType == "Tiered") {
    content = <SlabBased slabs={rateDetail?.rate || []} variant="bars" />;
  } else if (typeDisplay === 'Seasonal' || rateDetail?.basisType == "Seasonal") {
    content = <Seasonal seasons={rateDetail?.rate || []} />;
  } else {
    content = <FlatRate data={rateDetail?.rate || []} />;
  }

  return (
    <div className="w-full">
      <div className="mt-2 rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl font-bold text-slate-900">
            Rate Structure
          </h2>
          <div className="rounded-full border border-cyan-200 bg-cyan-50 px-5 py-2 text-sm font-semibold text-cyan-700">
            {typeDisplay}
          </div>
        </div>

        {content}
      </div>
    </div>
  );
}